import { JSXElementConstructor, ReactElement, useEffect } from "react";

import { LibraryView } from "common/constants";
import WorkspaceController, { WorkspaceControllerState } from "js/controllers/WorkspaceController";
import AppController, { AppControllerState } from "js/core/AppController";
import PresentationLibraryController, { PresentationFilterType, PresentationLibraryControllerState } from "js/controllers/PresentationLibraryController";

export interface PresentationLibraryControllerInitializerProps {
    children: ReactElement<any, string | JSXElementConstructor<any>>;
    view?: string;
    pane?: PresentationFilterType;
    folderId?: string;
    subFolderId?: string;
}

export const PresentationLibraryControllerInitializer = AppController.withState(WorkspaceController.withState(
    function PresentationLibraryControllerInitializer({
        view = LibraryView.LIBRARY,
        pane,
        folderId,
        subFolderId,
        children,

        user,
        workspaceId,
    }: PresentationLibraryControllerInitializerProps & WorkspaceControllerState & AppControllerState) {
        const parentControllersInitialized = AppController.initialized && WorkspaceController.initialized;

        useEffect(() => {
            if (!parentControllersInitialized || PresentationLibraryController.isInitialized) {
                return;
            }

            const librarySettings = user.getLibrarySettings();
            const viewType = (librarySettings?.viewType ?? "grid") as "grid" | "list";
            const field = librarySettings?.sortField ?? "modifiedAt";
            const reverse = librarySettings?.sortReverse ?? true;

            const initialStateValues: Partial<PresentationLibraryControllerState> & { workspaceId: string } = { workspaceId, viewType, sort: { field, reverse } };

            if (view === LibraryView.LIBRARY && pane) {
                initialStateValues.filter = { type: pane, folderId, subFolderId };
            }

            PresentationLibraryController.initialize(initialStateValues);
        }, [workspaceId, parentControllersInitialized]);

        useEffect(() => {
            if (!PresentationLibraryController.isInitialized || !parentControllersInitialized) {
                return;
            }

            if (view !== LibraryView.LIBRARY) {
                if (PresentationLibraryController.filter.type === PresentationFilterType.TRASH) {
                    PresentationLibraryController.setFilter({ type: PresentationFilterType.ALL_PRESENTATIONS, folderId: null, subFolderId: null });
                }
                return;
            }

            if (pane) {
                PresentationLibraryController.setFilter({ type: pane, folderId, subFolderId });
            }
        }, [view, pane, folderId, subFolderId]);

        return children;
    }
));
